import React from 'react';
import moment from 'moment-timezone';
import { SelectInput, MarkupProps } from 'blueprint-form';

const DOM_OPTIONS = Array.from(Array(28).keys()).map((day) => ({
  label: moment()
    .date(day + 1)
    .format('Do'),
  value: day + 1
}));

const DOM_EXTRA_OPTIONS = [29, 30, 31].map((day) => ({
  label: moment().date(day).format('Do'),
  value: day
}));

const DOM_NEVER_OPTION = {
  label: 'Never',
  value: -1
};

interface DayOfMonthProps extends MarkupProps {
  hasNever?: boolean;
  hasExtraDays?: boolean;
}

const DayOfMonth = ({
  label,
  name,
  large,
  fill,
  disabled,
  hasNever,
  hasExtraDays
}: DayOfMonthProps): JSX.Element => {
  label = label || 'Day of the Month';
  let options = DOM_OPTIONS;
  if (hasNever) {
    options = [DOM_NEVER_OPTION].concat(options);
  }
  if (hasExtraDays) {
    options = options.concat(DOM_EXTRA_OPTIONS);
  }
  return (
    <SelectInput
      label={label}
      name={name}
      large={large}
      fill={fill}
      disabled={disabled}
      options={options}
    />
  );
};

export default DayOfMonth;
